import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { Broadcaster } from '../../service/Broadcaster';
import { SingService } from '../../service/sing.service';
import { ActivatedRoute } from '@angular/router';
import { responseSaveExpense } from 'app/components/class/http/res/response-save-expense';
import { updateCategories } from 'app/components/class/broadcaster/update-categories';
import { renameSetCategori } from 'app/components/class/broadcaster/rename/rename-set-categori';
import { renameSetProduct } from 'app/components/class/broadcaster/rename/rename-set-product';
import { responsecreateProduct } from 'app/components/class/http/res/response-create-product';
import {Action} from './services/action.service';
import { Rights } from 'app/components/class/rights';

@Component({
  selector: 'app-left-panel',
  providers:[Action],
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.css']
})
export class LeftPanelComponent implements OnInit {

  data: any;
  categories = [];
  count = {
    categories: 0,
    products: 0,
    campaigns: 0
  }
  params:any;
  actual = false;
  addCategoryOpen: boolean = false;
  allCategories = [];
  categoryNames = [];
  newCategoryName: string = '';
  dealerGroupId;
  addInputOpen;
  addInput;
  typeMonth;
  productsList = [];
  newProductName: string = '';
  newProductAllIndex;
  rooftops = [];
 rights:Rights;
  constructor(
    private broadcaster: Broadcaster,
    private httpService: SingService,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private actions: Action
  ) { }

  ngOnInit() {

    $('[data-toggle="tooltip"]').tooltip({ animation: true });
    this.route.queryParams.subscribe(p => {
      this.dealerGroupId = p.id;
    });
    this.broadcaster.on<any>("updateCategories").subscribe((data:updateCategories) => {
      this.categories = data.categories;
     
  })
  if (this.actions.getAuthData().loggedIn !== "") {
    if (!this.actions.getAuthData().identity) return;
    
    this.rights = this.actions.getAuthData().identity.rights;
  }
  this.checkActualMode();
    this.broadcaster.on<any>('sendBudgetData').subscribe(data => {
      this.data = data.data;
      this.params =data.date;
      this.rooftops = data.data.rooftops;
      this.typeMonth = data.typeMonth;
     
      if (this.categories.length > 0)
      {
        this.closedAllategory();
      }
      this.categories = this.data.categories;
      this.convertTypes(data.data);
      this.counting();
      this.categoryNames = [];
      this.clearAddCategory();
      for (var i in this.allCategories) {
        let isListed = false;
        for (var j in this.data.categories) {
          if (this.allCategories[i].name === this.data.categories[j].title) {
            isListed = true;
          }
        }
        if (!isListed) {
       
          this.categoryNames.push(this.allCategories[i].name)
        }
      }
   
    });
    this.broadcaster.on<any>('sendNewBudgetData').subscribe(data => {
      this.data = data.data;
      this.params =data.date;
      this.rooftops = data.data.rooftops;
      this.typeMonth = data.typeMonth;
      //this.categories = this.data.categories;
      this.convertTypes(data.data);
      this.categoryNames = [];

    });
    this.broadcaster.on<any>('allCategories').subscribe(data => {
      this.allCategories = data.data;
     
      this.categoryNames = [];
      this.clearAddCategory();
      for (var i in this.allCategories) {
        let isListed = false;
        for (var j in this.categories) {
          if (this.allCategories[i].name === this.categories[j].title) {
            isListed = true;
          }
        }
        if (!isListed) {
          this.categoryNames.push(this.allCategories[i].name)
        }
      }
    });
    this.broadcaster.on<any>('updateMediaCategories').subscribe((data:Array<String>) => {
for (let i=0;i<this.categories.length;i++)
{
  let index :number = data.findIndex(item => item === String(this.categories[i].id));
  this.categories[i].mediaCategorie = (index !== (-1)) ? 1 : 0;
}

    });
    this.broadcaster.on<any>('renameSetCategori').subscribe((data:renameSetCategori) => {

      this.categories[data.indexCat].title = data.name;
      //  this.categories[data.indexCat].titleShort = (this.categories[data.indexCat].title.length > 20) ? this.categories[data.indexCat].title.substring(0, 15) + " ..." : null;

    });
    this.broadcaster.on<any>('renameSetProduct').subscribe((data:renameSetProduct) => {

      this.categories[data.indexCat].products[data.indexProduct].title = data.name;
      //    this.categories[data.indexCat].products[data.indexProduct].titleShort = (this.categories[data.indexCat].products[data.indexProduct].title.length > 30) ? this.categories[data.indexCat].products[data.indexProduct].title.substring(0, 25) + " ..." : null;

    });
    this.broadcaster.on<any>('saveCategory').subscribe(data => {
      let color,
        name,
        productCategoryId
      let categoryExists: boolean = false;
      if (this.newCategoryName === '') {
        return
      }
      for (let i in this.categories) {
        if (this.newCategoryName.toLowerCase() === this.categories[i].title.toLowerCase()) {
          return
        }
      }
      for (let i in this.allCategories) {
        if (this.newCategoryName.toLowerCase() === this.allCategories[i].name.toLowerCase()) {
          productCategoryId = this.allCategories[i].productCategoryId
          categoryExists = true;
        }
      }
      if (categoryExists === false) {
        color = data.color,
          name = this.newCategoryName
        this.httpService.CreateCategory(this.dealerGroupId, name, color).subscribe(data => {
          let expenses = [];
          for (var i in this.data.rooftops) {
            expenses.push({
              expense: "0",
              id: data.data.productCategoryId,
              actual: "0"
            })
          }
          let newCategory = {
            actualBudget: " 0",
            id: data.data.productCategoryId,
            title: data.data.name,
            price: 0,
            ordinal: parseInt(data.data.ordinal),
            products: [],
            targetBudget: " 0",
            expenses: expenses,
            color: data.data.color
          }
          this.broadcaster.broadcast('createNewCategory', {
            data: newCategory
          })
          this.counting();
          this.clearAddCategory();
        })
      } else if (categoryExists === true) {
        this.httpService.getCategori(productCategoryId, false).subscribe(data => {
          let expenses = [];
          for (var i in this.data.rooftops) {
            expenses.push({
              expense: "0",
              id: data.data.productCategoryId,
              actual: "0"
            })
          }
          let newCategory = {
            actualBudget: " 0",
            id: data.data.productCategoryId,
            title: data.data.name,
            price: 0,
            ordinal: parseInt(data.data.ordinal),
            products: [],
            targetBudget: " 0",
            expenses: expenses,
            color: data.data.color
          }
          this.broadcaster.broadcast('createNewCategory', {
            data: newCategory
          })
          this.counting();
          this.clearAddCategory();
          this.categoryNames.splice(this.categoryNames.indexOf(this.newCategoryName), 1);
        })
      }
    })
    this.broadcaster.on<any>("submitCampaign").subscribe(data => {
      let num = 0;
      for (let i of data.expenses) {
        let flights = [];
        for (let f of i.flightDate) {
          let flight = {
            end: "",
            start: "",
            targetBudget: 0
          };
          flight.end = `${f.end.year}-${f.end.month}-${f.end.day}`;
          flight.start = `${f.start.year}-${f.start.month}-${f.start.day}`
          flight.targetBudget = f.targetBudget;
          flights.push(flight)
        }
        let exData = {
          campaign: data.title,
          coop: i.coop,
          creativeId: i.creativeId,
          description: i.description,
          flightDate: flights,
          id: i.id,
          notes: i.notes,
          strategy: i.strategy,
          targetBudget: i.targetBudget
        };
        this.httpService.saveExpense(exData).subscribe((d:responseSaveExpense) => {
          num = num + 1;
          if (num === data.expenses.length) {
            this.broadcaster.broadcast("updateBudget", null);
            document.querySelector(".addCampaignModal").classList.add('hid')
            document.querySelector(".budgetContainer").classList.remove('blur')
          }
        })
      }
    })

  }
  checkActualMode() {
    if (window.localStorage.getItem('actualMode') && window.localStorage.getItem('actualMode') === "actual")
    {
      document.getElementById('changeActual').classList.add('activate');
    /*  this.broadcaster.broadcast("changeActualBudget", {
        data: "changing actual budget"
      })*/
      this.actual = true;
    } else {
      window.localStorage.setItem('actualMode',"target");
    }

  }
  ngAfterViewChecked() {
    this.fadeHeight();
  }
  counting() {
    this.count.categories = this.categories.length;
    this.count.products = 0;
    this.count.campaigns = 0;
    for (let c of this.categories) {
      this.count.products += c.products.length;
      for (let p of c.products) {
        if (p.subproducts) {
          this.count.campaigns += p.subproducts.length;
        }
      }
    }
  }
  convertTypes(d) {
    for (let c in d.categories) {
      this.categories[c].targetBudget = this.formatMoney(d.categories[c].targetBudget);
      this.categories[c].actualBudget = this.formatMoney(d.categories[c].actualBudget);
      for (let p in d.categories[c].products) {
        this.categories[c].products[p].targetBudget = this.formatMoney(d.categories[c].products[p].targetBudget);
        this.categories[c].products[p].actualBudget = this.formatMoney(d.categories[c].products[p].actualBudget);
        if (d.categories[c].products[p].subproducts && d.categories[c].products[p].subproducts.length > 0) {
          for (let q in d.categories[c].products[p].subproducts) {
           
            this.categories[c].products[p].subproducts[q].targetBudget = this.formatMoney(d.categories[c].products[p].subproducts[q].targetBudget);
            this.categories[c].products[p].subproducts[q].actualBudget = this.formatMoney(d.categories[c].products[p].subproducts[q].actualBudget);
          }
        }
      }
    }
  }
  formatMoney(n) {
    if (n % 1 === 0) {
      return ` ${n.toLocaleString('en')}`
    }
    var c = 2,
      d = ".",
      t = ",",
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
      j = (j = i.length) > 3 ? j % 3 : 0;
    return ` ${s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - parseFloat(i)).toFixed(c).slice(2) : "")}`;
  };
  getParentById(p, id: string) {
    let parent = p;
   
    while (parent.id !== id) {

      parent = parent.parentNode;
     

    }
    return parent;

  }
  closedAllategory() {
    for (let i=0;i<this.categories.length;i++)
    {
this.closedCategory(this.categories[i].id);
    }

  }
  closedCategory(product_id) {
    let mainTable;
    let tableDiv = <HTMLElement>document.getElementById(`${product_id}-price`);
        mainTable = <HTMLElement>document.getElementById(`${product_id}-title`);
        if (mainTable) {
         
          mainTable.classList.add('main');
          mainTable.classList.remove('sub');
        tableDiv.style.height = '0px';
        tableDiv.style.overflowY = 'hidden';
        setTimeout(() => {
          this.fadeHeight()
        }, 200)
        }
       
  }
 
  growDiv(e, product_id, type, media) {
    
    let srcElm;
    let elm;
    let arrow;
    if (e.srcElement) {
      
      srcElm = <HTMLElement>e.srcElement;
      /*  let count = this.elRef.nativeElement.querySelectorAll(`#${e.srcElement.parentNode.id}`).length;
      */
      elm = this.getParentById(e.srcElement, e.srcElement.parentNode.id);//document.getElementById(e.srcElement.parentNode.id);// (count === 0) ? document.getElementById(e.srcElement.parentNode.id) : this.elRef.nativeElement.querySelectorAll(`#${e.srcElement.parentNode.id}`)[count - 1];

      arrow = e.srcElement.lastElementChild;
    } else if (e.target) {
     
      srcElm = <HTMLElement>e.target;
    
      elm = this.getParentById(srcElm, e.target.parentNode.id);//document.getElementById(e.target.parentNode.id);
      arrow = e.target.lastElementChild;
    }
    let mainTable;
   
    let tableDiv = <HTMLElement>document.getElementById(`${product_id}-price`);
    let child = <HTMLElement>elm.lastElementChild;
    let parentDiv = <HTMLElement>elm.parentNode.parentNode;
    
    let tableParent = <HTMLElement>tableDiv.parentNode.parentNode;
    let line = <HTMLElement>document.getElementById(`${product_id}-line`);
    child.style.height = `${child.clientHeight}px`;
    tableDiv.style.height = `${child.clientHeight}px`;
    let wrapper = elm.lastElementChild.firstElementChild;
   
    if (child.clientHeight) {
      if (type === 'sub') {
        parentDiv.style.height = null;
        tableParent.style.height = null;
      } else if (type === 'main') {
        mainTable = <HTMLElement>document.getElementById(`${product_id}-title`);
        mainTable.classList.add('main');
        mainTable.classList.remove('sub');
        
       
      }
      child.style.height = '0px';
      tableDiv.style.height = '0px';
      arrow.classList.remove('open');
      child.style.overflowY = 'hidden';
      tableDiv.style.overflowY = 'hidden';
      srcElm.classList.add('closed');
      srcElm.classList.remove('open');
      line.classList.remove('open');
      line.classList.add('closed');
      setTimeout(() => {
        this.fadeHeight()
      }, 200)
    } else {
      if (type === 'sub') {
        parentDiv.style.height = null;
        tableParent.style.height = null;
      } else if (type === 'main') {
        mainTable = <HTMLElement>document.getElementById(`${product_id}-title`);
        mainTable.classList.add('sub');
        mainTable.classList.remove('main');
       
      }
      let cHeight = 0;
      if (this.typeMonth && this.rights.canManageOwnBudgets === 1) {
       cHeight = (type === 'main') ?  wrapper.clientHeight + 49 : wrapper.clientHeight;
      
  
    
      } else {
        cHeight = wrapper.clientHeight;
      }
    
      child.style.height = `${cHeight}px`;
      tableDiv.style.height = `${cHeight}px`;
      arrow.classList.add('open');
      srcElm.classList.add('open');
      srcElm.classList.remove('closed');
      line.classList.add('open');
      line.classList.remove('closed');
      setTimeout(() => {
        this.fadeHeight()
        child.style.overflowY = null;
        tableDiv.style.overflowY = null;
      }, 200)
    }
  
  }
  fadeHeight() {
    const fadeLeft = document.getElementById('mainTableLeftScroll');
    const height = (this.getHeight(fadeLeft) - 150);
    fadeLeft.style.height = `${height}px`;
  }
  getHeight(elem) {
    return elem.parentElement.clientHeight;
  }
  changeActual() {
    let actualArr = [].slice.call(document.getElementsByClassName('actual'));
    let targetArr = [].slice.call(document.getElementsByClassName('target'));

    if (!this.actual) {
      /*for(let i of actualArr){
        i.classList.remove('hid');
      }
      for(let i of targetArr){
        i.classList.add('hid');
      }*/
      document.getElementById('changeActual').classList.add('activate');
      this.broadcaster.broadcast("changeActualBudget", {
        data: "changing actual budget"
      })
      this.actual = true;
      window.localStorage.setItem('actualMode',"actual");
    } else {
      /*for(let i of actualArr){
        i.classList.add('hid');
      }
      for(let i of targetArr){
        i.classList.remove('hid');
      }*/
      document.getElementById('changeActual').classList.remove('activate');
      this.broadcaster.broadcast("changeActualBudget", {
        data: "changing actual budget"
      })
      this.actual = false;
      window.localStorage.setItem('actualMode',"target");
    }
  }
  rightClick(e, type, id, c, p, q) {
    let pos = {
      x: e.x,
      y: e.y
    }
    let source = e.target;
    let expenses = [];
    let indexes = {
      category: c,
      product: p,
      campaign: q
    }
    if (type === "campaign") {
      expenses = this.data.categories[c].products[p].subproducts[q].expenses;
    }
    this.broadcaster.broadcast('openContext', {
      position: pos,
      source: source,
      type: type,
      id: id,
      rooftops: this.rooftops,
      expenses: expenses,
      indexes: indexes,
      isMedia: (this.categories[c].mediaCategorie === 1) ? true :  false
    })
    return false
  }
  addCategoryMenu(e) {
    if (!this.addCategoryOpen) {
      $('.addCategoryInput').autocomplete({
        source: this.categoryNames,
        select: (event, ui) => {
          this.newCategoryName = ui.item.value;
        }
      });
      this.addCategoryOpen = true;
      document.getElementById('addCategoryOpen').classList.remove('hid');
      (<HTMLInputElement>document.querySelector('#addCategoryOpen input')).focus();
      this.broadcaster.broadcast('addCategoryMenu', {
        data: "open"
      })
    }
    if (e.target.classList.contains('xIcon')) {
      this.addCategoryOpen = false;
      document.getElementById('addCategoryOpen').classList.add('hid');
      this.broadcaster.broadcast('addCategoryMenu', {
        data: "close"
      })
    }
  }
  categoryInputChange(e) {
    this.newCategoryName = e.target.value;
  }
  clearAddCategory() {
    let input = <HTMLInputElement>document.getElementById("addCategoryInput");
    if (input !== null) {
      input.value = '';
    }
    this.addCategoryOpen = false;
    document.getElementById('addCategoryOpen').classList.add('hid');
    this.broadcaster.broadcast('addCategoryMenu', {
      data: "close"
    })
  }
  showInput(e, cat) {
    this.newProductAllIndex = this.allCategories.findIndex((c) => {
      return c.name == cat.title
    });
    this.addProductAuto(this.newProductAllIndex, cat);

    if (this.addInputOpen) {
      this.addInput.classList.add('hid');
    } else {
      this.addInputOpen = true;
    }
    this.addInput = document.getElementById(`${cat.id}-addInput`);
    this.addInput.classList.remove('hid');
    this.addInput.focus();

  }
  addProductAuto(index, cat) {
    let arr = [];
    if (this.allCategories[index]) {
      for (let p of this.allCategories[index].products) {
        let isListed = false;
        for (let q of cat.products) {
          if (p.name == q.title) {
            isListed = true;
          }
        }
        if (!isListed) {
          arr.push(p.name)
        }
      }
      this.productsList = arr;
      $(`#${cat.id}-addInput`).autocomplete({
        source: arr,
        select: (event, ui) => {
          let i = this.categories.indexOf(cat);
          this.newProductName = ui.item.value;
          this.submitProduct(event, cat.id, i);
        }
      });
    }
  }
  productInputChange(e) {
    this.newProductName = e.target.value;
  }
  submitProduct(e, id, index) {
   
   
    if (e !== null && e.key === "Enter") {
     
      let productExists: boolean = false,
        productId,
        ordinal,
        title;
      if (this.newProductName === '') {
      
        return
      }
      for (let i of this.categories[index].products) {
        if (i.title.toLowerCase() === this.newProductName.toLowerCase()) {
         
          return
        }
      }
let indexCat:number = this.allCategories.findIndex(item => item.productCategoryId === this.categories[index].id);
      if (this.allCategories[indexCat]) {
        for (let i of this.allCategories[indexCat].products) {
          if (this.newProductName.toLowerCase() === i.name.toLowerCase()) {
          
            productId = i.productId;
            productExists = true;
            ordinal = i.ordinal;
            title = i.name;
          }
        }
      }

      let expenses = [];
      for (let i in this.data.rooftops) {
        let expense = {
          expense: "0",
          id: 0,
          actual: "0"
        }
        expenses.push(expense);
      }
     
      if (productExists === false) {
        let newProduct = {
          name: this.newProductName,
          description: '',
          strategy: '',
          productCategoryId: id
        };
       
        this.httpService.createProduct(newProduct).subscribe((data:responsecreateProduct) => {
        
       

            let newP = {
              actualBudget: " 0",
              expenses: expenses,
              id: data.productId,
              ordinal: data.ordinal,
              targetBudget: " 0",
              title: data.name
            };
           
            this.categories[index].products.push(newP);
            this.addInput.classList.add('hid');
            this.addInput.value = '';
          /*  this.httpService.addExpense({
              dealerShipId:this.params.dealerGroupId,
              month:this.params.month,
              year:this.params.year,
              productId: data.data.productId,
              productCategoryId: id,
              targetBudget: 0,
              actualBudget: 0,
              flightDate:  [ {
                start: `${this.params.year}-${(this.params.month < 10) ? "0" + this.params.month : this.params.month}-01`,
                end: `${this.params.year}-${(this.params.month < 10) ? "0" + this.params.month : this.params.month}-${32 - new Date(this.params.year, this.params.month, 32).getDate()}`,
                targetBudget: 0
            }],
              campaign: "",
              strategy: "",
              description: "",
              notes: "",
              coop: 0,
              creativeId: "",
              add_comapin: ""
            })
            .subscribe(res => {
                if (res.status === 200) {
                  let newP = {
                    actualBudget: " 0",
                    expenses: this.data.rooftops.map((item) =>
                    {
                      res.data.expense.expense = 0;
                      res.data.expense.actual = 0;
                      return res.data.expense;
                    }),
                    id: data.data.productId,
                    ordinal: data.data.ordinal,
                    targetBudget: " 0",
                    title: data.data.name
                  };
                  console.log('newP',newP);
                  this.categories[index].products.push(newP);
                  this.addInput.classList.add('hid');
                  this.addInput.value = '';
                }
              });*/
          
         
        })
      } else {
        let newP = {
          actualBudget: " 0",
          expenses: expenses,
          id: productId,
          ordinal: ordinal,
          targetBudget: " 0",
          title: title
        };
    
        this.categories[index].products.push(newP);
        this.addInput.classList.add('hid');
        this.addInput.value = '';
      }
    } else if (e.type === "autocompleteselect") {
      let productId,
        ordinal,
        title,
        expenses = [];
      for (let i of this.allCategories[this.newProductAllIndex].products) {
        if (this.newProductName.toLowerCase() === i.name.toLowerCase()) {
          productId = i.productId;
          ordinal = i.ordinal;
          title = i.name;
        }
      }
      for (let i in this.data.rooftops) {
        let expense = {
          expense: "0",
          id: 0,
          actual: "0"
        }
        expenses.push(expense);
      }
      let newP = {
        actualBudget: " 0",
        expenses: expenses,
        id: productId,
        ordinal: ordinal,
        targetBudget: " 0",
        title: title
      };
     
      this.categories[index].products.push(newP);
      this.addInput.classList.add('hid');
      this.addInput.value = '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/left-panel/left-panel.component.ts